import { render } from "./OddsMatchContentDetail.vue?vue&type=template&id=2b1cbaea"
import script from "./OddsMatchContentDetail.vue?vue&type=script&lang=js"
export * from "./OddsMatchContentDetail.vue?vue&type=script&lang=js"

import "./OddsMatchContentDetail.vue?vue&type=style&index=0&id=2b1cbaea&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__